// Styles
import { atQuery } from '../../scripts/components/mediaQueries';
import { loadMinicart, openMinicart } from '../../scripts/components/minicart';
import {
  createOmnibusEndpoint,
  getOmnibusPriceFromAPI,
  renderOmnibusPriceFromAPI,
} from '../../scripts/components/omnibus';
import { headerHeight } from '../../scripts/helpers';
import './template-product.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateProduct = (context) => {
  const templateProductSection = context.closest('.shopify-section');
  if (!templateProductSection) return;

  const productForm = templateProductSection.querySelector('.product__form');
  if (
    typeof ShopifyAPI !== 'undefined' &&
    typeof ShopifyAPI.addItemFromForm !== 'undefined'
  ) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      ShopifyAPI.addItemFromForm(
        productForm,
        async () => {
          await loadMinicart();
          openMinicart();
        },
        (XMLHttpRequest, textStatus) => {
          const errorWrapper = productForm.querySelector(
            '.product-form__error',
          );
          if (errorWrapper && XMLHttpRequest?.responseJSON?.description) {
            errorWrapper.innerText = XMLHttpRequest.responseJSON.description;
            setTimeout(() => {
              errorWrapper.innerText = '';
            }, 5000);
          }
        },
      );
    });
  }

  templateProductSection
    .querySelectorAll('.product-form-option__active-value')
    .forEach((optionOpener) => {
      const optionContainer = optionOpener.closest('.product-form__option');
      if (!optionContainer) return;
      const optionDrawer = optionContainer.querySelector(
        '.product-form-option__drawer',
      );
      if (!optionDrawer) return;

      optionOpener.addEventListener('click', () =>
        optionDrawer.classList.add('open'),
      );

      optionDrawer
        .querySelectorAll(
          '.btn-close, .product-form-option__drawer-backdrop, .product-form-option__drawer-footer a',
        )
        .forEach((optionsCloser) => {
          optionsCloser.addEventListener('click', () =>
            optionDrawer.classList.remove('open'),
          );
        });
    });

  const shippingTooltip = templateProductSection.querySelector(
    '.product-form__shipping-tooltip',
  );
  if (shippingTooltip) {
    templateProductSection
      .querySelectorAll('.product-form__shipping-info')
      .forEach((shippingInfo) => {
        shippingInfo.addEventListener('click', (e) => {
          e.stopPropagation();
          shippingTooltip.classList.add('open');
        });
      });

    document.querySelectorAll('#PageContainer, #header').forEach((closeCta) =>
      closeCta.addEventListener('click', (e) => {
        if (
          e.target.classList.contains('product-form__shipping-tooltip-close') ||
          e.target.closest('.product-form__shipping-tooltip-close')
        ) {
          shippingTooltip.classList.remove('open');
        } else if (
          !e.target.classList.contains(
            'product-form__shipping-tooltip-inner',
          ) &&
          !e.target.closest('.product-form__shipping-tooltip-inner')
        ) {
          shippingTooltip.classList.remove('open');
        }
      }),
    );
  }

  const selectedOption = productForm.querySelector(
    `select[name="id"] option[selected][data-stock]`,
  );
  const qtySelectorInput = document.querySelector('.js-qty__num');
  const qtySelectorBtnMinus = document.querySelector('.js-qty__adjust--minus');
  const qtySelectorBtnPlus = document.querySelector('.js-qty__adjust--plus');

  const handleQtyButtons = () => {
    if (
      !qtySelectorInput ||
      !qtySelectorBtnMinus ||
      !qtySelectorBtnPlus ||
      typeof qtySelectorInput.dataset.stock === 'undefined'
    )
      return;

    if (parseInt(qtySelectorInput.value) <= 1) {
      qtySelectorBtnMinus.disabled = true;
    } else {
      qtySelectorBtnMinus.disabled = false;
    }

    if (
      parseInt(qtySelectorInput.value) >=
      parseInt(qtySelectorInput.dataset.stock)
    ) {
      qtySelectorBtnPlus.disabled = true;
    } else {
      qtySelectorBtnPlus.disabled = false;
    }
  };

  if (qtySelectorInput && qtySelectorBtnMinus && qtySelectorBtnPlus) {
    if (selectedOption) {
      qtySelectorInput.setAttribute('data-stock', selectedOption.dataset.stock);
    } else {
      qtySelectorInput.setAttribute('data-stock', 1);
    }

    [qtySelectorBtnMinus, qtySelectorBtnPlus].forEach((el) => {
      el.addEventListener('click', () => {
        handleQtyButtons();
      });
    });

    handleQtyButtons();
  }

  const renderOmnibusPrice = async function (
    container,
    vId = false,
    vPrice = false,
    vHasPromo = false,
  ) {
    const variantID = vId || container.getAttribute('data-omnibus_id');
    const variantPrice = vPrice || container.getAttribute('data-variant_price');
    const brand = container.getAttribute('data-omnibus_brand');
    const currency = container.getAttribute('data-currency');
    const hasPromo = vHasPromo || container.getAttribute('data-promo');

    renderOmnibusPriceFromAPI(
      container,
      await getOmnibusPriceFromAPI(brand, variantID, currency),
      variantPrice,
      hasPromo,
    );
  };

  const getOBContainers = function () {
    const omnibusContainers = document.querySelectorAll(
      '[data-omnibus_price-container]',
    );
    const OBContainersByEndpoint = {};

    if (omnibusContainers && omnibusContainers.length) {
      const OBContainers = Array.prototype.slice.call(omnibusContainers);

      OBContainers.map((container) => {
        const currentID = container.getAttribute('data-omnibus_id');
        const currentBrand = container.getAttribute('data-omnibus_brand');
        const currentCurrency = container.getAttribute('data-currency');
        const currentEndpoint = createOmnibusEndpoint(
          currentBrand,
          currentID,
          currentCurrency,
        );

        if (!OBContainersByEndpoint[currentEndpoint])
          OBContainersByEndpoint[currentEndpoint] = [];
        OBContainersByEndpoint[currentEndpoint].push(container);
      });
    }

    return OBContainersByEndpoint;
  };

  const OBContainersByEndpoint = getOBContainers();
  for (const [endpoint, containers] of Object.entries(OBContainersByEndpoint)) {
    for (let i = 0; i < containers.length; ++i) {
      renderOmnibusPrice(containers[i]);
    }
  }

  $(context).on('variantChange', (e) => {
    if (!e || !e.variant || !e.product) return;
    const OBContainersByEndpoint = getOBContainers();

    for (const [endpoint, containers] of Object.entries(
      OBContainersByEndpoint,
    )) {
      for (let i = 0; i < containers.length; ++i) {
        renderOmnibusPrice(containers[i], e.variant.id, e.variant.price);
      }
    }

    if (e.variant.featured_image) {
      const newImage = templateProductSection.querySelector(
        `[data-image-id="${e.variant.featured_image.id}"]`,
      );
      const activeImage = templateProductSection.querySelector(
        '.product__image--active',
      );
      const defaultImage = templateProductSection.querySelector(
        '[data-image-id="default"]',
      );
      if (activeImage && (newImage || defaultImage)) {
        activeImage.classList.remove('product__image--active');
      }
      if (newImage) {
        newImage.classList.add('product__image--active');
      } else if (defaultImage) {
        defaultImage.classList.add('product__image--active');
      }
    }

    e.variant.options.forEach((option, i) => {
      const optionWrapper = templateProductSection.querySelector(
        `.product-form__option[data-option-index="${i}"]`,
      );
      if (!optionWrapper) return;
      const optionLabel = optionWrapper.querySelector(
        '.product-form-option__active-value span',
      );
      if (optionLabel) {
        optionLabel.innerText = option;
      }

      optionWrapper
        .querySelectorAll('.product-form-option__drawer-value')
        .forEach((valueWrapper) => {
          if (!valueWrapper.querySelector('input')) return;
          const changedValue = valueWrapper.querySelector('input').value;
          const options = e.variant.options.map((value, j) =>
            i == j ? changedValue : value,
          );
          const newVariant = e.product.variants.find((variant) =>
            variant.options.every((value, j) => value === options[j]),
          );

          if (!newVariant) return;

          const imageField = valueWrapper.querySelector(
            '.product-form-option__drawer-value-image img',
          );
          if (imageField && newVariant.featured_image) {
            imageField.src = newVariant.featured_image.src;
          }

          const readyToShip = valueWrapper.querySelector(
            '.product-form-option__drawer-value-rts',
          );
          const masterSelectOption = templateProductSection.querySelector(
            `select[name="id"] option[value="${newVariant.id}"][data-ready-to-ship]`,
          );
          if (readyToShip && masterSelectOption) {
            if (masterSelectOption.dataset.readyToShip == 'true') {
              readyToShip.classList.remove('hidden');
            } else {
              readyToShip.classList.add('hidden');
            }
          }

          const price = valueWrapper.querySelector(
            '.product-form-option__drawer-value-price',
          );
          if (
            price &&
            typeof theme?.Currency?.formatMoney !== 'undefined' &&
            theme?.strings?.moneyFormat
          ) {
            price.innerText = theme.Currency.formatMoney(
              newVariant.price,
              theme.strings.moneyFormat,
            );
          }
        });
    });

    const selectedOption = productForm.querySelector(
      `select[name="id"] option[value="${e.variant.id}"][data-stock][data-ready-to-ship]`,
    );
    if (selectedOption) {
      if (qtySelectorInput) {
        qtySelectorInput.value = '1';
        qtySelectorInput.setAttribute(
          'data-stock',
          selectedOption.dataset.stock,
        );
        handleQtyButtons();
      }

      const readyToShip = templateProductSection.querySelector(
        '.product-info__ready-to-ship',
      );
      if (readyToShip) {
        if (selectedOption.dataset.readyToShip == 'true') {
          readyToShip.classList.remove('hidden');
        } else {
          readyToShip.classList.add('hidden');
        }
      }
    }

    const activeShippingInfo = templateProductSection.querySelector(
      '.product-form__shipping-info--active',
    );
    if (activeShippingInfo) {
      activeShippingInfo.classList.remove(
        'product-form__shipping-info--active',
      );
    }
    const newShippingInfo = templateProductSection.querySelector(
      `.product-form__shipping-info[data-variant-id="${e.variant.id}"]`,
    );
    if (newShippingInfo) {
      newShippingInfo.classList.add('product-form__shipping-info--active');
    }
  });
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
    window.dAgency.initTemplateProduct(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
      window.dAgency.initTemplateProduct(el);
    });
  });
}
